import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { InputProduto, TProdutosRessuprimento } from "..";
import PaperDraggable from "../../../../PaperDraggable";

export default function DialogObservacoes({ open, handleClose, onChange, selecionado, row, selecionados }: DialogObservacoesProps) {

    const [observacoes, setObservacoes] = useState(selecionado?.observacao ?? "")

    // Funções manipuladoras
    const handleChangeObservacao = (operation: "clean" | "add") => {
        let newSelecionados: Array<InputProduto> = [...selecionados];
        const params: InputProduto = {
            codigo: row.codigo,
            nome: row.nome,
            quantidade: selecionado?.quantidade ?? 0,
            observacao: operation === "clean" ? null : observacoes,
            encomenda: selecionado?.encomenda ?? null,
            departamento: row.departamento,
            setor: row.setor,
            estoque_total: row.estoque_origem,
            unidade_medida: row.unidade_medida,
        }

        let index = newSelecionados.findIndex((i) => i.codigo === row.codigo);

        if (index === -1) newSelecionados.push(params)
        if (index !== -1) newSelecionados[index] = params

        onChange(newSelecionados);
        handleClose();
    }

    return (

        <Dialog
            fullWidth
            maxWidth="xs"
            open={open}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            scroll="body"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Observação</DialogTitle>

            <DialogContent>
                <Alert severity="info" icon={false}>
                    <Typography variant="subtitle1">{selecionado?.nome}</Typography>
                </Alert>

                <Box mt={2}>
                <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    maxRows={6}
                    variant="outlined"
                    label="Observação"
                    value={observacoes}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setObservacoes(event.target.value)
                    }}  
                />

                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    variant="text"
                    onClick={() => handleChangeObservacao("clean")}
                >
                    Limpar
                </Button>
                <Button
                    variant="contained"
                    onClick={() => handleChangeObservacao("add")}
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogObservacoesProps {
    open: boolean;
    row: TProdutosRessuprimento;
    selecionados: InputProduto[];
    selecionado: InputProduto | null;
    handleClose: () => void;
    onChange: (produtos: Array<InputProduto>) => void;
}